import {FullWidthSidebar, useLayout} from "@twigsby/frontend-framework";
import React, {useEffect, useRef} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import SendsNavigation from "../../Components/SendMail/Shared/Controls/SendsNavigation";
import SendsHistoryControl from "../../Components/SendsAdmin/Controls/SendsHistoryControl";
import SendMailHistoryProvider from "../../Providers/SendMailHistoryProvider";
import SendsHistoryFilterControl, {SendHistoryFilterButton} from "../../Components/SendsAdmin/Controls/SendsHistoryFilterControl";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const History = () => {
    const { t } = useTranslation();
    const { isLarge } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();
    const sendsHistoryRef = useRef<any>();
    const sendMailNavigationRef = useRef<any>();

    useEffect(() => {
        updatePageMeta({
            title: t('sends.profilesHistory.title')
        });
    }, [currentLocale]);

    return (
        <SendMailHistoryProvider>
            <FullWidthSidebar
                ref={sendsHistoryRef}
                navigationComponent={
                    <SendsNavigation
                        ref={sendMailNavigationRef}
                        title={t('sends.profilesHistory.title')}
                        addonContent={
                            <>
                                {!isLarge && (
                                    <>
                                        <div className={'section-navigation-header-collapsed-addon'}>
                                            <SendHistoryFilterButton />
                                        </div>
                                        <SendsHistoryFilterControl />
                                    </>
                                )}
                            </>
                        }
                    />
                }
                extraContentClass={`flex-column `}
            >
                <SendsHistoryControl linkToSendsItem={true} containerRef={sendsHistoryRef} />
            </FullWidthSidebar>
        </SendMailHistoryProvider>
    )
}

export default History
